/**
 * Util xử lý các vấn đề liên quan đến datetime
 * @author DNThang - 27.11.2019
 */
import i18n from '@/i18n/i18n';
import moment from 'moment';
let mo = moment;
mo.locale('vi');

class DateUtil {
	/**
	 * Đọc đến ngày
	 * @param {} toDate
	 * nmtruong 14/3/2020
	 */
	sayToDate(toDate) {
		const me = this;
		if (toDate) {
			toDate = new Date(
				toDate.getFullYear(),
				toDate.getMonth(),
				toDate.getDate()
			);
			return i18n
				.t('I18NDateRange.ToDateFormat')
				.format(me.formatDateToString(toDate));
		} else {
			return i18n.t('I18NDateRange.ToDateFormat').format('');
		}
	}
	/**
	 * Đọc ngày tháng năm căn cứ theo năm tài chính
	 * Rule:
	 *  - Tròn ngày: Ngày dd tháng MM năm yyyy
	 *  - Tròn tháng: Tháng MM năm yyyy
	 *  - Tròn quý: Quý QQ năm yyyy
	 *  - Tròn năm: Năm yyy
	 *  - Khác: Từ ngày dd/MM/yyy đến ngày dd/MM/yyyy
	 * @author DNThang - 27.11.2019
	 */
	sayDate(fromDate, toDate) {
		let me = this,
			//Ngày hạch toán hiện tại
			fiscallDate = session.SystemDate,
			//Ngày bắt đầu năm tài chính
			fiscalFromDate = session.FiscalFromDate,
			//Ngày kết thúc năm tài chính
			fiscalToDate = session.FiscalToDate,
			fiscalYear = fiscallDate.getFullYear(),
			//Năm tài chính hiện tại
			iCurrenYear = fiscalYear,
			//Ngày bắt đầu của năm tài chính hiện tại
			startDateOfCurrentYear = new Date(
				fiscalYear,
				fiscalFromDate.getMonth(),
				fiscalFromDate.getDate()
			),
			//Ngày kết thúc của năm tài chính hiện tại
			finishDateOfCurrentYear = new Date(
				fiscalYear,
				fiscalToDate.getMonth(),
				fiscalToDate.getDate()
			),
			sResult = '',
			localize = i18n;

		//Loại bỏ giờ của tham số fromDate, toDate (nếu có)
		fromDate = new Date(
			fromDate.getFullYear(),
			fromDate.getMonth(),
			fromDate.getDate()
		);
		toDate = new Date(
			toDate.getFullYear(),
			toDate.getMonth(),
			toDate.getDate()
		);

		//Thực hiện tính toán ra Ngày bắt đầu và Ngày kết thúc của năm tài chính theo kỳ báo cáo hiện tại
		if (
			fromDate != startDateOfCurrentYear ||
			toDate != finishDateOfCurrentYear
		) {
			let iDiffYear = 0;
			if (fromDate < fiscalFromDate) {
				//Nếu từ ngày < ngày bắt đầu năm tài chính thì tính số năm chênh lệch
				iDiffYear =
					fromDate.getFullYear() - fiscalFromDate.getFullYear();
				//Nếu cộng thêm số năm chênh lệch rồi mà vẫn < hơn thì phải trừ thêm 1 năm nữa (trường hợp ngày bắt đầu năm tài chính không phải là 01/01)
				let dTemp = new Date(fiscalFromDate);
				if (fromDate < dTemp.addYears(iDiffYear)) {
					iDiffYear = iDiffYear - 1;
				}
				//Tính năm tài chính đang in báo cáo
				iCurrenYear = fiscalYear + iDiffYear;
				startDateOfCurrentYear = new Date(fiscalFromDate);
				startDateOfCurrentYear = startDateOfCurrentYear.addYears(
					iDiffYear
				);
				finishDateOfCurrentYear = new Date(startDateOfCurrentYear);
				finishDateOfCurrentYear = finishDateOfCurrentYear
					.addYears(1)
					.addDays(-1);
			} else if (fromDate > fiscalToDate) {
				//Nếu từ ngày > ngày bắt đầu năm tài chính thì tính số năm chênh lệch
				iDiffYear = fromDate.getFullYear() - fiscalToDate.getFullYear();
				//Nếu cộng thêm số năm chênh lệch rồi mà vẫn > hơn thì phải cộng thêm 1 năm nữa (trường hợp ngày bắt đầu năm tài chính không phải là 01/01)
				let dTemp = new Date(fiscalToDate);
				if (fromDate > dTemp.addYears(iDiffYear)) {
					iDiffYear = iDiffYear + 1;
				}
				//Tính năm tài chính đang in báo cáo
				iCurrenYear = fiscalYear + iDiffYear;
				//Tính ngày bắt đầu của năm tài chính đang in báo cáo
				startDateOfCurrentYear = new Date(fiscalToDate);
				startDateOfCurrentYear = startDateOfCurrentYear
					.addYears(iDiffYear - 1)
					.addDays(1);
				//Tính ngày kết thúc của năm đang in báo cáo. Trừ năm tài chính đầu tiên cho phép 15 tháng, các năm sau chỉ đc 12 tháng nên luôn cộng 1
				finishDateOfCurrentYear = new Date(startDateOfCurrentYear);
				finishDateOfCurrentYear = finishDateOfCurrentYear
					.addYears(1)
					.addDays(-1);
			}
		}

		//Thực hiện đọc Ngày tháng
		if (fromDate.equalDateOnly(toDate)) {
			sResult = me.sayDateFormat(fromDate);
		} else if (
			fromDate.equalDateOnly(startDateOfCurrentYear) &&
			toDate.equalDateOnly(finishDateOfCurrentYear)
		) {
			//Tròn năm
			sResult = localize
				.t('I18NDateRange.YearFormat')
				.format(iCurrenYear.toString());
		} else if (
			fromDate.getDate() === 1 &&
			toDate.equalDateOnly(new Date(fromDate).addMonths(1).addDays(-1))
		) {
			//Tròn tháng
			let month = fromDate.getMonth() + 1,
				sMonth = (month < 3 ? '0' : '') + month.toString();
			sResult = localize
				.t('I18NDateRange.MonthFormat')
				.format(sMonth, iCurrenYear.toString());
		} else if (
			fromDate.equalDateOnly(startDateOfCurrentYear) &&
			toDate.equalDateOnly(
				new Date(startDateOfCurrentYear).addMonths(3).addDays(-1)
			)
		) {
			//Quý 1
			sResult = localize
				.t('I18NDateRange.QuarterFormat')
				.format('1', iCurrenYear.toString());
		} else if (
			fromDate.equalDateOnly(
				new Date(startDateOfCurrentYear).addMonths(3)
			) &&
			toDate.equalDateOnly(
				new Date(startDateOfCurrentYear).addMonths(6).addDays(-1)
			)
		) {
			//Quý 2
			sResult = localize
				.t('I18NDateRange.QuarterFormat')
				.format('2', iCurrenYear.toString());
		} else if (
			fromDate.equalDateOnly(
				new Date(startDateOfCurrentYear).addMonths(6)
			) &&
			toDate.equalDateOnly(
				new Date(startDateOfCurrentYear).addMonths(9).addDays(-1)
			)
		) {
			//Quý 3
			sResult = localize
				.t('I18NDateRange.QuarterFormat')
				.format('3', iCurrenYear.toString());
		} else if (
			fromDate.equalDateOnly(
				new Date(startDateOfCurrentYear).addMonths(9)
			) &&
			toDate.equalDateOnly(
				new Date(startDateOfCurrentYear).addMonths(12).addDays(-1)
			)
		) {
			//Quý 4
			sResult = localize
				.t('I18NDateRange.QuarterFormat')
				.format('4', iCurrenYear.toString());
		} else {
			//Từ ngày
			sResult = localize
				.t('I18NDateRange.FromDateToDateFormat')
				.format(
					me.formatDateToString(fromDate),
					me.formatDateToString(toDate)
				);
		}

		return sResult;
	}

	/**
	 * Chuyển từ kiểu DateTime sang string theo định dạng
	 * @param {Date} date Ngày cần format
	 */
	formatDateToString(date) {
		let ret = '';
		if (date) {
			let localize = i18n,
				dateString = this.parseDateTimeToString(
					date,
					localize.t('I18NDateRange.FullDateFormat')
				),
				dateStringFormat = localize
					.t('I18NDateRange.ReportDateFormat')
					.toLowerCase();

			ret = dateStringFormat.format(dateString);
		}

		return ret;
	}

	/**
	 * Đọc từ giá trị Date ra chuỗi Ngày Tháng Năm
	 * @param {Date} date Ngày cần đọc
	 * @param {Boolean} isFullDate Có hiển thị đầy đủ ngày tháng không: các giá trị <= 2 thì sẽ thêm 0 ở đầu
	 */
	sayDateFormat(date, isFullDate = true) {
		let ret = '';
		if (date && date instanceof Date) {
			let localize = i18n,
				dateFormat = localize.t('I18NDateRange.DateFormat'),
				day = date.getDate(),
				sDay = (isFullDate && day < 10 ? '0' : '') + day.toString(),
				month = date.getMonth() + 1,
				sMonth =
					(isFullDate && month < 3 ? '0' : '') + month.toString(),
				sYear = date.getFullYear().toString();

			ret = dateFormat.format(sDay, sMonth, sYear);
		}

		return ret;
	}

	/**
	 * Convert từ giá trị DateTime sang string
	 * @param {DateTime} value Giá trị datetime cần convert
	 * @param {String} formatString Định dạng string datetime cần convert
	 */
	parseDateTimeToString(value, formatString) {
		if (value) {
			//Nếu là DateTime mới xử lý parse
			if (value instanceof Date) {
				let m = mo(value),
					ret = m.format(formatString);

				return ret;
			} else {
				return value;
			}
		}
	}

	/**
	 * Convert từ string sang DateTime
	 * @param {String/DateTime} value Giá trị cần convert ra DateTime
	 * @param {String} formatString Định dạng string datetime (nếu value là string)
	 */
	parseToDate(value, formatString) {
		if (value) {
			if (value instanceof Date) {
				return value;
			} else if (typeof value == 'string' && formatString) {
				let m = mo(value, formatString);

				if (m && m.isValid()) {
					return m.toDate();
				}
			}
		}

		return value;
	}

	/**
	 * Convert từ jsonDate sang DateTime
	 * @param {String/DateTime} value Giá trị cần convert ra DateTime
	 */
	parseJsonToDate(value) {
		if (value instanceof Date) {
			return value;
		}

		const dateFormat = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(.)?(\d{0,9})?(Z)?(\+)?(\d{2})?(:)?(\d{2})?$/;

		if (typeof value === 'string' && dateFormat.test(value)) {
			return new Date(value);
		}

		return value;
	}
}

export default new DateUtil();

/**
 * Định dạng ngày tháng kiểu 01/12/2020
 */
export const FORMAT_DD_MM_YYYY = 'DD/MM/YYYY';
